import 'date-input-polyfill-react'
import { useController } from 'react-hook-form'
import Datepicker from 'components/Datepicker/Datepicker'
import moment from 'moment'

const HFDatepicker = (props) => {
	const { name, optionsAlign, initialDate, ...attributes } = props
	const {
		field: { ref, value, ...field },
	} = useController({ name })

	return (
		<Datepicker
			{...attributes}
			{...field}
			value={value}
			initialDate={
				initialDate || value ? moment(value || initialDate) : null
			}
			onChange={(date) => {
				const isoDate = date.toISOString()
				field.onChange(isoDate)
			}}
		/>
	)
}

export default HFDatepicker
